// src/lib/bet-root-display.js -- bet-level display values derived from the legs (#1682).
//
// Single job: answer three display questions -- which game an SGP is on, what matchup its header
// names, and which object a single's market is read from -- from the legs when the bets row
// leaves the root field unset.
// Reads: the client bet (storage.js rowToBet). Writes: nothing.
// Does NOT: grade, settle, or feed status (betting.js grades from the legs already), and never
// guesses: legs that disagree give null, and the caller keeps its placeholder.
//
// Why: SlipSync writes a multi with root game_id, pick and teams NULL (api/lib/slipsync/handler.js,
// root game_id is singles-only), and rowToBet sets no bet-level market. Display that read the root
// found nothing: no SGP start time or score strip, a "—" header, no single market label.

// The one value every leg that carries one agrees on, or null.
function sharedLegValue(bet, pick) {
  const values = new Set();
  for (const leg of Array.isArray(bet?.legs) ? bet.legs : []) {
    const v = pick(leg);
    if (v !== null && v !== undefined && v !== "") values.add(String(v));
  }
  return values.size === 1 ? [...values][0] : null;
}

// The game an SGP is on: its root game_id (screenshot SGPs), else the game its legs share.
export function sgpGameId(bet) {
  if (bet?.slipType !== "sgp") return null;
  if (bet.gameId) return String(bet.gameId);
  return sharedLegValue(bet, (leg) => leg?.gameId);
}

// The SGP header: root teams, else the teams its legs share, else the matched game's away @ home.
export function sgpMatchup(bet, game) {
  if (bet?.teams) return bet.teams;
  const legTeams = sharedLegValue(bet, (leg) => leg?.teams);
  if (legTeams) return legTeams;
  const away = game?.away?.team;
  const home = game?.home?.team;
  return away && home ? `${away} @ ${home}` : null;
}

// What a single's market is read from: its one leg, unless the bet itself carries a market
// (legacy client-built bets). rowToBet puts the market only on the leg.
export function singleMarketSource(bet) {
  const hasRootMarket = !!(bet?.canonicalMarket || bet?.market);
  const legs = Array.isArray(bet?.legs) ? bet.legs : [];
  return !hasRootMarket && legs.length === 1 ? legs[0] : bet;
}
